<template>
  <div>
    <div class="tw-flex tw-justify-center tw-items-center tw-mb-4">
      <button
        type="button"
        class="button"
        :class="{ active: isEmailActive }"
        @click="switchForm('email')"
      >
        {{ $t("template.login_form_email", "By Email") }}
      </button>
      <span class="separator"> OR </span>
      <button
        type="button"
        class="button"
        :class="{ active: isPhoneActive }"
        @click="switchForm('phone')"
      >
        {{ $t("template.login_form_phone", "By Phone") }}
      </button>
    </div>

    <slot v-if="isEmailActive" name="email"></slot>
    <slot v-if="isPhoneActive" name="phone"></slot>
  </div>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
  name: "LoginFormManager",
  data() {
    return {
      activeForm: "email", // 'email' or 'phone'
    };
  },
  computed: {
    isEmailActive() {
      return this.activeForm === "email";
    },
    isPhoneActive() {
      return this.activeForm === "phone";
    },
  },
  methods: {
    switchForm(formType) {
      this.activeForm = formType;
      this.$emit("switchForm", formType);
    },
  },
});
</script>

<style lang="scss" scoped>
.button {
  @apply tw-px-5 tw-py-3 tw-bg-blue-400 tw-text-white tw-rounded-full hover:tw-bg-blue-500;
  font-family: "VitoExtended-Bold", sans-serif;
  &.active {
    @apply tw-bg-red-400;
  }
}
.separator {
  @apply tw-mx-2 tw-text-gray-500;
}
</style>
